import * as React from 'react'
import { ReactElement, useState } from 'react'
import { baseListStyles } from '../BaseList'
import { css, Icon, Link, Stack, StackItem, Text } from '@fluentui/react'
import { IDocumentOverviewItemDto } from '../../../config/documentConfig'
import { DocumentListItemProps, documentStyles } from './DocumentListItem'
import { Destination } from '../../../context/AxiosContext'
import StealthLink from '../../../components/StealthLink'
import { DocumentNodeType } from '../../../config/documentConfig'
import { formatDocumentNodeName } from '../../../helpers/documentHelper'
import { getApplicationIconPropsByFileName } from '../../../helpers/iconHelper'
import useViewport from '../../../hooks/useViewport'
import DocumentPreview from '../../Preview/DocumentPreview'
import { useBoolean } from '@fluentui/react-hooks'
import useIsTouchDevice from '../../../hooks/useIsTouchDevice'
import FormattedDateTime from '../../Date/FormattedDateTime'

function PreviewButton({ item, reset }: { item: IDocumentOverviewItemDto; reset: () => void }): ReactElement {
    const ref = React.useRef<HTMLDivElement>()
    const [visible, { setTrue: show, setFalse: hide }] = useBoolean(false)

    return (
        <DocumentPreview item={item} targetRef={ref} visible={visible} hide={hide} reset={reset}>
            <Link
                onMouseDown={event => event.stopPropagation()}
                onClick={event => {
                    show()
                    event.stopPropagation()
                }}
                ref={ref}
                styles={{ root: documentStyles.icon }}
            >
                <Icon iconName="RedEye" />
            </Link>
        </DocumentPreview>
    )
}

export default function DocumentCell(props: DocumentListItemProps<IDocumentOverviewItemDto>): ReactElement {
    const { width } = useViewport()
    const isTouchDevice = useIsTouchDevice()
    const [isSelectable, setSelectable] = useState<boolean>(false)

    return (
        <Stack
            horizontal
            verticalAlign="center"
            tokens={{ childrenGap: 's1' }}
            className={css(baseListStyles.itemCell, props.isSelected && 'is-selected')}
            data-is-focusable={true}
            data-selection-index={props.index}
            data-selection-toggle={true}
            onMouseEnter={() => setSelectable(true)}
            onMouseLeave={() => setSelectable(false)}
        >
            <Stack verticalAlign="center" horizontalAlign="center">
                <Icon {...getApplicationIconPropsByFileName(props.item.name, 16)} styles={{ root: documentStyles.icon }} />
                {width <= 480 && <PreviewButton item={props.item} reset={props.reset} />}
            </Stack>
            <Stack
                horizontal={width > 480}
                verticalAlign="baseline"
                tokens={{ childrenGap: width > 480 && 'm' }}
                grow
                styles={{ root: baseListStyles.overflowCell }}
            >
                <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 's1' }} grow styles={{ root: baseListStyles.overflowCell }}>
                    <StackItem styles={{ root: baseListStyles.overflowCell }}>
                        <Text variant="medium" block nowrap onMouseDown={event => event.stopPropagation()} onClick={event => event.stopPropagation()}>
                            <StealthLink id={props.item.id} url={props.item.url} destination={Destination.Documents}>
                                {formatDocumentNodeName(props.item.name, DocumentNodeType.Document)}
                            </StealthLink>
                        </Text>
                    </StackItem>
                    {width > 480 && <PreviewButton item={props.item} reset={props.reset} />}
                </Stack>
                <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 's1' }}>
                    <StackItem styles={{ root: width > 480 && documentStyles.largeDate }}>
                        <FormattedDateTime date={props.item.date} />
                    </StackItem>
                </Stack>
            </Stack>
            {(isSelectable || isTouchDevice || props.isSelected) && (
                <Link styles={{ root: documentStyles.icon }}>
                    <Icon iconName="Touch" />
                </Link>
            )}
        </Stack>
    )
}
